module.exports = __webpack_public_path__ + "img/Manchi.68fbfba7.webp";